import './GlobalPreferencePanel.scss';

import { Icon } from '@travelwin/core';
import classNames from 'classnames';
import {
  SelectorType,
  globalPreferenceClassName,
} from './GlobalPreferencePanel';
import { ShowTo } from '../../../components/ShowTo';

const GlobalPreferencePanelButton = ({
  variant = 'dropdown',
  isFocused,
  selectors,
  onClick,
}: {
  variant?: 'dropdown' | 'full-screen';
  isFocused: boolean;
  selectors: SelectorType[];
  onClick?: () => void;
}) => {
  return (
    <div
      className={classNames(
        [
          `${globalPreferenceClassName}__button`,
          `${globalPreferenceClassName}__button--${variant}`,
        ],
        {
          [`${globalPreferenceClassName}__button--focused`]: isFocused,
        },
      )}
      onClick={onClick}
      data-testid="switcher-currency"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' && onClick) {
          onClick();
        }
      }}
    >
      {selectors.map(({ id, showTo, buttonLabel }: SelectorType, index) => (
        <ShowTo key={id} brands={showTo}>
          {index > 0 && <Icon name="lineIcon" />}
          {buttonLabel}
        </ShowTo>
      ))}
    </div>
  );
};

export default GlobalPreferencePanelButton;
